import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ProjectTitle } from '../../project.model';

@Component({
  selector: 'app-project-selection-header-tab-item',
  templateUrl: './project-selection-header-tab-item.component.html',
  styleUrls: ['./project-selection-header-tab-item.component.scss']
})
export class ProjectSelectionHeaderTabItemComponent {

  projectTitle: ProjectTitle
  title: string;

  @Input("projectTitle") set setProjectTitle(projectTitle: ProjectTitle) {
    this.projectTitle = projectTitle;
    this.updateProjectLabel();
  }

  @Input() selected: boolean;

  @Output()
  close = new EventEmitter<any>();

  @Output()
  select = new EventEmitter<any>();

  constructor() { }

  closeTab($event: any) {
    $event.stopPropagation();
    this.close.next(this.projectTitle.id);
  }

  selectTab() {
    this.select.next(this.projectTitle.id);
  }

  private updateProjectLabel() {
    this.title = this.projectTitle.title;
  }
}
